/**
 * 挂载位置类型
 */
export default {
    0: {
        key: 0,
        name: '请选择'
    },

    1: {
        key: 1,
        name: '电脑网页'
    },

    2: {
        key: 2,
        name: '手机网页'
    },

    3: {
        key: 3,
        name: '线下物料'
    },

    4: {
        key: 4,
        name: '短信邮件'
    },

    5: {
        key: 5,
        name: '公众号图文'
    },
    6: {
        key: 6,
        name: '公众号底部栏'
    },
    7: {
        key: 7,
        name: '微信搜一搜'
    },
    8: {
        key: 8,
        name: '微信小程序'
    },
    9: {
        key: 9,
        name: '微信支付凭证'
    },
    10: {
        key: 10,
        name: '其他'
    }
};
